// extracted by mini-css-extract-plugin
export var text = "_h-0";